import { createFileRoute } from '@tanstack/react-router'
import { FefcoEditor } from './-FefcoEditor'

export const Route = createFileRoute('/packaging/fefcos/$id')({
  component: EditFefcoPage,
})

function EditFefcoPage() {
  const { id } = Route.useParams()
  return <FefcoEditor id={id} />
}
